// Instellingen als overzicht (Turks). Zelfde vorm als settingsHub.nl.ts.
export const appSettingsHubTr = {
    groups: {
        family: {
            title: 'Ailemiz',
            titleHouse: 'Hanemiz',
            body: 'Kimlerin dahil olduğu, dil ve size neyin uyduğu.',
        },
        agenda: {
            title: 'Takvim',
            body: 'Dışarıdaki takvimleri ekleyin, paylaşın ve dışa aktarın.',
        },
        board: {
            title: 'Pano ve tabletler',
            body: 'Duvardaki tabletler, odalar, kilit ve hava durumu.',
        },
        modules: {
            title: 'Modüller',
            body: 'Hangi bölümleri kullandığınız ve her birinin kendi ayarları.',
        },
        account: {
            title: 'Hesabınız',
            body: 'Giriş ve güvenlik, telefonunuzdaki bildirimler ve uygulamanın görünümü.',
        },
        privacy: {
            title: 'Gizlilik ve veriler',
            body: 'Verilerinizi indirin veya silin, kimin bakabileceğini seçin.',
        },
    },
    household: {
        title: 'Hane',
        intro: 'Ad, dil ve hane türü tek bir yerde.',
        nameTitle: 'Ad ve saat dilimi',
        nameBody: 'Ad panoda ve e-postalarda görünür.',
    },
    calendar: {
        title: 'Takvimi bağlayın ve dışa aktarın',
        intro: 'Abonelik bağlantıları, yol süresi ve dosya olarak takvim.',
    },
    locationWeather: {
        title: 'Konum ve hava durumu',
        intro: 'Nerede yaşadığınız ve panonun hava durumu hakkında gösterdikleri.',
    },
    // WP3: vijf onderdelen, Bord en Gezin met tabbladen.
    sections: {
        label: 'Ayar bölümleri',
        household: 'Hane',
        family: 'Aile ve gelenekler',
        house: 'Evimize uyanlar',
        agenda: 'Takvim',
        modules: 'Modüller',
        account: 'Hesap ve gizlilik',
        accountState: 'Güvenlik, bildirimler, tema ve verilerin',
    },
    change: 'Değiştir',
    /** Rechts in een regel die alleen uitleg opent (geen keuze). */
    view: 'Görüntüle',
    rows: {
        name: 'Ad ve saat dilimi',
        language: 'Dil',
        type: 'Hane türü',
        location: 'Konum',
        weather: 'Panoda hava durumu',
        feeds: 'Dış takvimler',
        feedsState: 'Okul, spor ve iş takviminizde',
        sync: 'Google veya Outlook bağla',
        syncState: 'İki yönlü, kişi başına',
        links: 'Abonelik bağlantıları',
        linksState: 'Takviminiz başka bir uygulamada (tek yön)',
        export: 'Dışa aktar',
        exportState: 'Takvim dosya olarak (.ics)',
        theme: 'Tema ve piktogramlar',
        about: 'AMUMIN hakkında',
        off: 'Kapalı',
        nothing: 'Henüz bir şey seçilmedi',
        ownChoices: 'Kendi seçimleri: {names}',
    },
    hubs: {
        board: {
            title: 'Pano',
            tabs: 'Pano bölümleri',
            view: 'Görünüm',
            tablets: 'Tabletler',
            rooms: 'Odalar',
            frame: 'Fotoğraf çerçevesi',
            kidLock: 'Çocuk kilidi',
        },
        family: {
            title: 'Aile',
            tabs: 'Aile bölümleri',
            members: 'Üyeler',
            links: 'Akrabalar',
            circle: 'Çevre',
        },
    },
    tablets: {
        none: 'Henüz bağlı tablet yok.',
        guide: 'iPad nasıl bağlanır',
    },
    members: {
        order: 'Sıralama',
        orderDone: 'Tamam',
    },
    modulesCount: '{total} modülden {on} tanesi açık',
    privacyStatement: 'Gizlilik bildirimi',
    privacyStatementBody: 'Neyi, neden ve ne kadar süre sakladığımız.',
    haptics: {
        label: 'Dokununca titreşim',
        hint: 'Bir şeye bastığında kısa bir titreşim (yalnızca bunu yapabilen bir telefonda).',
        boardHint: 'Biri panoda bir şeye bastığında kısa bir titreşim. iPad titremez; orada basışı yine de görürsün.',
    },
};
//# sourceMappingURL=settingsHub.tr.js.map